import { render, staticRenderFns } from "./aPricingStrategyCardStrategyGuardrail.vue?vue&type=template&id=a768466a&scoped=true"
import script from "./aPricingStrategyCardStrategyGuardrail.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyCardStrategyGuardrail.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyCardStrategyGuardrail.vue?vue&type=style&index=0&id=a768466a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a768466a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VChip,VDialog,VIcon})
